// Public routes
export const PUBLIC_ROUTES = {
	LOGIN: "/login",
};

// Private routes
export const PRIVATE_ROUTES = {
	DASHBOARD: "/",
	LOGS: "/logs",
	LECTURES: "/lectures/:departmentId",
	DEPARTMENT: "/department",
	SCHEDULE: "/schedule",
	TEACHERS: "/teachers",
	SUBJECTS: "/subjects",
	CLASSES: "/classes",
	PARENTS: "/parents",
	SETTINGS: "/settings",
	STUDENTS: "/students",
	ATTENDANCE: "/attendance/:departmentId",
	COURSE: "/courses/:subject",
	GRADES: "/grades/:departmentId",
	ASSESSMENTS: "/assessments/:departmentId",
};

// Route groups for sidebar navigation
export const ROUTE_GROUPS = {
	MAIN: [
		PRIVATE_ROUTES.DASHBOARD,
		PRIVATE_ROUTES.LOGS,
		PRIVATE_ROUTES.ASSESSMENTS,
		PRIVATE_ROUTES.GRADES,
		PRIVATE_ROUTES.ATTENDANCE,
	],
	ACADEMIC: [
		PRIVATE_ROUTES.LECTURES,
		PRIVATE_ROUTES.COURSE,
		PRIVATE_ROUTES.DEPARTMENT,
	],
	ADMINISTRATIVE: [
		PRIVATE_ROUTES.TEACHERS,
		PRIVATE_ROUTES.SUBJECTS,
		PRIVATE_ROUTES.CLASSES,
		PRIVATE_ROUTES.PARENTS,
		PRIVATE_ROUTES.STUDENTS,
	],
};
